export const PARTNER_ROLES = [
    "INTERNSHIP_MENTOR",
    "WORKSHOP_MENTOR",
    "SERVICE_INTERVIEWER",
    "PRODUCT_INTERVIEWER",
    "MAANG_INTERVIEWER",
] as const;
export const PARTNER_SPECIALTIES = ["Frontend", "Backend", "React", "JavaScript", "Firebase", "Java", "Python", "DSA", "System Design", "UI/UX", "HR / Communication"] as const;
export const INTERVIEW_ROUNDS = ["TECHNICAL", "CODING", "SYSTEM_DESIGN", "HR"] as const;

export type PartnerRole = typeof PARTNER_ROLES[number];
export type InterviewTier = "SERVICE" | "PRODUCT" | "MAANG";

export const INTERVIEWER_ROLES = [
    "SERVICE_INTERVIEWER",
    "PRODUCT_INTERVIEWER",
    "MAANG_INTERVIEWER",
] as const satisfies readonly PartnerRole[];

const INTERVIEW_TIER_BY_ROLE: Partial<Record<PartnerRole, InterviewTier>> = {
    SERVICE_INTERVIEWER: "SERVICE",
    PRODUCT_INTERVIEWER: "PRODUCT",
    MAANG_INTERVIEWER: "MAANG",
};

export function interviewTiersForRoles(roles: readonly string[]): InterviewTier[] {
    return INTERVIEWER_ROLES
        .filter((role) => roles.includes(role))
        .map((role) => INTERVIEW_TIER_BY_ROLE[role] as InterviewTier);
}

export function hasInterviewRole(roles: readonly string[]) {
    return interviewTiersForRoles(roles).length > 0;
}

export function mentorRoleForCourseType(courseType: string): PartnerRole | null {
    if (courseType === "INTERNSHIP") return "INTERNSHIP_MENTOR";
    if (courseType === "WORKSHOP") return "WORKSHOP_MENTOR";
    return null;
}

export function partnerRoleLabel(role: string) {
    const labels: Record<string, string> = {
        INTERNSHIP_MENTOR: "Internship Mentor",
        WORKSHOP_MENTOR: "Workshop Mentor",
        SERVICE_INTERVIEWER: "Service Company Interviewer",
        PRODUCT_INTERVIEWER: "Product Company Interviewer",
        MAANG_INTERVIEWER: "MAANG Interviewer",
    };
    return labels[role] || role.split("_").map((word) => word.charAt(0) + word.slice(1).toLowerCase()).join(" ");
}
